/* =========================================
   STRIPOP Shopify theme script
   ========================================= */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => root.querySelectorAll(sel);

  /* ---------- トースト ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $("#toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("is-show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove("is-show"), 2400);
  }

  /* ---------- モバイルメニュー ---------- */
  const menuBtn = $("#menuBtn");
  const nav = $("#nav");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", open);
    });
    nav.addEventListener("click", (e) => {
      if (e.target.closest("a")) {
        nav.classList.remove("is-open");
        menuBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---------- スクロール表示 ---------- */
  const revealTargets = $$(".reveal, .feature, .faq__item, .concept__inner > *");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.1 }
    );
    revealTargets.forEach((n) => {
      n.classList.add("reveal");
      io.observe(n);
    });
  }

  /* ---------- 数量ボタン ---------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".qty [data-step]");
    if (!btn) return;
    const input = btn.parentElement.querySelector("input");
    const min = Number(input.min || 0);
    const max = Number(input.max || 99);
    input.value = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + Number(btn.dataset.step)));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- カート追加（Ajax） ---------- */
  async function updateCartCount() {
    try {
      const res = await fetch(window.routes.cart_url + ".js", { headers: { Accept: "application/json" } });
      const cart = await res.json();
      const count = $("#cartCount");
      if (count) count.textContent = cart.item_count;
    } catch {
      /* 失敗しても表示更新しないだけ */
    }
  }

  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!form.matches("[data-ajax-cart], #product-form")) return;
    // 「今すぐ購入」ボタンなど、カート追加以外の送信はそのまま通す
    if (e.submitter && e.submitter.name === "checkout") return;
    e.preventDefault();

    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const res = await fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || window.strings.error);
      toast(`${window.strings.added}：${data.product_title || ""}`);
      updateCartCount();
    } catch (err) {
      toast(err.message || window.strings.error);
    } finally {
      if (button) button.disabled = false;
      syncVariant();
    }
  });

  /* ---------- 商品ページ：バリエーション選択 ---------- */
  const variantsEl = $("#productVariants");
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const selects = $$(".option__select");
  const money = (cents) =>
    "¥" + Math.round(cents / 100).toLocaleString("ja-JP");

  function syncVariant() {
    if (!variants.length || !selects.length) return;
    const chosen = [...selects].map((s) => s.value);
    const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    const addBtn = $("#addToCart");
    const idInput = $("#variantId");

    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = "選択できません";
      return;
    }
    idInput.value = variant.id;
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? "カートに入れる" : "SOLD OUT";
    $("#productPrice").textContent = money(variant.price);

    const compare = $("#comparePrice");
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compare.textContent = money(variant.compare_at_price);
      compare.hidden = false;
    } else {
      compare.hidden = true;
    }

    if (variant.featured_image) setMainImage(variant.featured_image.src, "", variant.featured_image.alt || "");

    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url);
  }
  selects.forEach((s) => s.addEventListener("change", syncVariant));

  /* ---------- 商品ページ：画像切り替え ---------- */
  function setMainImage(src, srcset, alt) {
    const img = $("#mainImage");
    if (!img) return;
    img.src = src;
    if (srcset) img.srcset = srcset;
    else img.removeAttribute("srcset");
    img.alt = alt;
  }
  $$(".detail__thumb").forEach((thumb) =>
    thumb.addEventListener("click", () => {
      $$(".detail__thumb").forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
      setMainImage(thumb.dataset.src, thumb.dataset.srcset, thumb.dataset.alt);
    })
  );

  /* ---------- カートページ：数量変更で自動更新 ---------- */
  const cartForm = $("#cart-form");
  if (cartForm) {
    let timer;
    cartForm.addEventListener("change", (e) => {
      if (!e.target.matches("[data-auto-submit]")) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        const update = document.createElement("input");
        update.type = "hidden";
        update.name = "update";
        update.value = "1";
        cartForm.appendChild(update);
        cartForm.submit();
      }, 500);
    });
  }

  /* ---------- コレクション：並び替え ---------- */
  const sort = $("[data-sort]");
  if (sort) {
    sort.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }
})();
